export default __webpack_public_path__ + "static/media/linkedin.c9915f78.svg";